<template>
  <div class="layer">
    <div class="inner categoryInner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">내비게이션</h2>
      <div class="flexBox innerContent">
        <!-- 상단바 -->
        <div class="flexInner">
          <div class="mb30">
            <div class="label groupLabel mb15">상단바</div>
            <!-- 배경색 -->
            <div class="mb15">
              <div class="label setLabel mb5">배경 색상</div>
              <ColorPicker
                class="mt5"
                :target="'top.backgroundColor'"
                :color="top.backgroundColor"
                :useColorOnly="true"
                @changeColor="changeColor" />
            </div>
            <!-- //배경색 -->
            <!-- 영역 높이 -->
            <div class="mb15">
              <div class="label setLabel mb5">영역 높이</div>
              <div class="unitInput">
                <input type="text" class="input" v-model="top.height">
                <span class="unit">px</span>
              </div>
            </div>
            <!-- //영역 높이 -->
            <!-- 로고이미지 -->
            <div class="mb15">
              <div class="label setLabel">로고 이미지</div>
              <div v-if="top.logo" class="bgThumb">
                <img :src="top.logo" alt="">
                <button type="button" class="delThumb" @click="deleteImage('top.logo')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
              </div>
              <div v-else>
                <input type="file" id="upload_top_logo" @change="uploadImage($event, 'top.logo')">
                <label for="upload_top_logo" class="btn toUppercase">{{locale.upload}}</label>
              </div>
            </div>
            <!-- //로고이미지 -->
            <!-- 영역 높이 -->
            <div class="mb15">
              <div class="label setLabel mb5">로고 이미지 높이</div>
              <div class="unitInput">
                <input type="text" class="input" v-model="top.logoHeight">
                <span class="unit">px</span>
              </div>
            </div>
            <!-- //영역 높이 -->
          </div>
        </div>
        <!-- //상단바 -->
        <!-- 카테고리바 -->
        <div class="flexInner">
          <div>
            <div class="label groupLabel mb15">카테고리바</div>
            <!-- 배경색 -->
            <div class="mb15">
              <div class="label setLabel mb5">배경 색상</div>
              <ColorPicker
                class="mt5"
                :target="'category.backgroundColor'"
                :color="category.backgroundColor"
                :useColorOnly="true"
                @changeColor="changeColor" />
            </div>
            <!-- //배경색 -->
            <!-- 구분선색 -->
            <div class="mb15">
              <div class="label setLabel mb5">구분선 색상</div>
              <ColorPicker
                class="mt5"
                :target="'category.borderColor'"
                :color="category.borderColor"
                :useColorOnly="true"
                @changeColor="changeColor" />
            </div>
            <!-- //구분선색 -->
            <!-- 영역 높이 -->
            <div class="mb15">
              <div class="label setLabel mb5">영역 높이</div>
              <div class="unitInput">
                <input type="text" class="input" v-model="category.height">
                <span class="unit">px</span>
              </div>
            </div>
            <!-- //영역 높이 -->
            <div class="label setLabel mb5">글자</div>
              <div class="mb5">
                <label>서체</label>
                <select class="input select mb5" v-model="category.fontFamily.default">
                  <option v-for="family in getFonts"
                    :key="family"
                    :value="family">
                    {{ family }}
                  </option>
                </select>
                <select class="input select mb5" v-model="category.fontFamily.default2">
                  <option v-for="family in getFonts"
                    :key="family"
                    :value="family">
                    {{ family }}
                  </option>
                </select>
                <select class="input select" v-model="category.fontFamily.default3">
                  <option v-for="family in getFonts"
                    :key="family"
                    :value="family">
                    {{ family }}
                  </option>
                </select>
              </div>
              <div class="mb5">
                <label>색상</label>
                <ColorPicker
                  class="mt5"
                  :target="'category.text.color'"
                  :color="category.text.color"
                  :useColorOnly="true"
                  @changeColor="changeColor" />
              </div>
              <div class="mb5">
                <label>크기</label>
                <div class="unitInput">
                  <input type="text" class="input" v-model="category.text.size">
                  <span class="unit">px</span>
                </div>
              </div>
              <div class="mb5">
                <label>자간</label>
                <div>
                  <select class="input select" v-model="category.text.spacing">
                    <option
                      v-for="spacing in spacingList"
                      :key="spacing"
                      :value="spacing">
                      {{ spacing }}
                    </option>
                  </select>
                </div>
              </div>
          </div>
        </div>
        <!-- //카테고리바 -->
        <!-- 아이콘 -->
        <div class="flexInner" data-responsive="icon">
          <div class="label groupLabel mb15">아이콘</div>
          <!-- 뒤로가기아이콘 -->
          <div class="mb15">
            <div class="label setLabel">뒤로가기 아이콘</div>
            <div class="mb5">
              <label>이미지</label>
              <div v-if="backIcon.image" class="bgThumb">
                <img :src="backIcon.image" alt="">
                <button type="button" class="delThumb" @click="deleteImage('backIcon.image')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
              </div>
              <div v-else>
                <input type="file" id="upload_back_icon" @change="uploadImage($event, 'backIcon.image')">
                <label for="upload_back_icon" class="btn toUppercase">{{locale.upload}}</label>
              </div>
            </div>
            <div>
              <label>크기</label>
              <div class="unitInput">
              <input type="text" class="input" v-model="backIcon.size">
              <span class="unit">px</span>
            </div>
            </div>
          </div>
          <!-- //뒤로가기아이콘 -->
          <!-- 메뉴아이콘 -->
          <div class="mb15">
            <div class="label setLabel">메뉴 아이콘</div>
            <div class="mb5">
              <label>열기</label>
              <div v-if="menuIcon.image" class="bgThumb">
                <img :src="menuIcon.image" alt="">
                <button type="button" class="delThumb" @click="deleteImage('menuIcon.image')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
              </div>
              <div v-else>
                <input type="file" id="upload_menu_icon" @change="uploadImage($event, 'menuIcon.image')">
                <label for="upload_menu_icon" class="btn toUppercase">{{locale.upload}}</label>
              </div>
            </div>
            <div>
              <label>크기</label>
              <div class="unitInput">
              <input type="text" class="input" v-model="menuIcon.size">
              <span class="unit">px</span>
            </div>
            </div>
          </div>
          <!-- //메뉴아이콘 -->
          <!-- 마이컬렉션아이콘 -->
          <div class="mb15">
            <div class="label setLabel">마이 컬렉션 아이콘</div>
            <div class="mb5">
              <label>기본</label>
              <div v-if="myCollectionIcon.default" class="bgThumb">
                <img :src="myCollectionIcon.default" alt="">
                <button type="button" class="delThumb" @click="deleteImage('myCollectionIcon.default')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
              </div>
              <div v-else>
                <input type="file" id="upload_mycollection_default" @change="uploadImage($event, 'myCollectionIcon.default')">
                <label for="upload_mycollection_default" class="btn toUppercase">{{locale.upload}}</label>
              </div>
            </div>
            <div class="mb5">
              <label>활성화</label>
              <div v-if="myCollectionIcon.active" class="bgThumb">
                <img :src="myCollectionIcon.active" alt="">
                <button type="button" class="delThumb" @click="deleteImage('myCollectionIcon.active')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
              </div>
              <div v-else>
                <input type="file" id="upload_mycollection_active" @change="uploadImage($event, 'myCollectionIcon.active')">
                <label for="upload_mycollection_active" class="btn toUppercase">{{locale.upload}}</label>
              </div>
            </div>
            <div>
              <label>크기</label>
              <div class="unitInput">
              <input type="text" class="input" v-model="myCollectionIcon.size">
              <span class="unit">px</span>
            </div>
            </div>
          </div>
          <!-- //마이컬렉션아이콘 -->
        </div>
        <!-- //아이콘 -->
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" @click="save">{{ locale.save }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import ColorPicker from '@/components/Util/ColorPicker'

export default {
  name: 'CollectionNav',
  props: [
    'locale',
    'pageId'
  ],
  components: {
    ColorPicker
  },
  computed: {
    getFonts () {
      return this.$store.getters['setting/getFonts']
    }
  },
  async created () {
    this.$store.commit('onLoading', true)
    // letter-spacing 옵션
    function createSpacing () {
      const min = -100
      const max = 250
      const diff = 25
      const arr = []
      for (let i = min; i <= max; i += diff) {
        arr.push(`${i}`)
      }
      return arr
    }
    this.spacingList = createSpacing()
    this.setFontsDefault()
    await this.getCollectionNav()
    this.$store.commit('onLoading', false)
  },
  data () {
    return {
      spacingList: [],
      top: {
        backgroundColor: 'rgba(255,255,255,1)',
        height: '100',
        logo: '',
        logoHeight: '60'
      },
      menuIcon: {
        image: '',
        size: ''
      },
      myCollectionIcon: {
        default: '',
        active: '',
        size: ''
      },
      backIcon: {
        image: '',
        size: ''
      },
      category: {
        backgroundColor: 'rgba(255,255,255,1)',
        borderColor: 'rgba(0,0,0,0.16)',
        height: '50',
        fontFamily: {
          default: '',
          default2: '',
          default3: '',
        },
        text: {
          color: 'rgba(200,200,200,1)',
          size: '20',
          spacing: '0'
        },
        activeStyle: 'line', // line, block
        activeColor: 'rgba(30,30,30,1)', // 라인이면 메뉴 하단 보더, 블럭이면 배경
        activeTextColor: 'rgba(255,255,255,1)'
      }
    }
  },
  methods: {
    setFontsDefault () {
      const fontSetting = this.$store.getters['setting/getData']?.font
      this.category.fontFamily.default = fontSetting.default
      this.category.fontFamily.default2 = fontSetting.default2
      this.category.fontFamily.default3 = fontSetting.default3
    },
    // 내비게이션 설정 호출
    async getCollectionNav () {
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/getCollectionNav', this.pageId)
      const nav = res?.message?.naviSetting
      if (nav) {
        this.top = this._.merge(this.top, nav.top)
        this.menuIcon = nav.menuIcon
        this.myCollectionIcon = nav.myCollectionIcon
        this.backIcon = nav.backIcon
        this.category = this._.merge(this.category, nav.category)
      } else {
        alert(this.locale.system_error)
      }
      this.$store.commit('onLoading', false)
    },
    changeColor (data) {
      const path = data.target.split('.')
      let target = this
      for (let i = 0; i < path.length - 1; i++) {
        if (!target[path[i]]) return
        target = target[path[i]]
      }
      target[path[path.length - 1]] = data.color
    },
    uploadImage (e, target) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      const path = target.split('.')
      let dataTarget = this
      for (let i = 0; i < path.length - 1; i++) {
        if (!dataTarget[path[i]]) return
        dataTarget = dataTarget[path[i]]
      }
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          dataTarget[path[path.length - 1]] = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteImage (target) {
      const path = target.split('.')
      let dataTarget = this
      for (let i = 0; i < path.length - 1; i++) {
        if (!dataTarget[path[i]]) return
        dataTarget = dataTarget[path[i]]
      }
      if (window.confirm(this.locale.confirm_delete)) {
        dataTarget[path[path.length - 1]] = ''
      }
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    },
    async save () {
      const data = {
        pageId: this.pageId,
        naviSetting: {
          top: this.top,
          menuIcon: this.menuIcon,
          myCollectionIcon: this.myCollectionIcon,
          backIcon: this.backIcon,
          category: this.category
        }
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/putCollectionNav', data)
      if (res?.status === 200) {
        alert(this.locale.complete_save)
        // await this.getCollectionNav()
        this.$emit('close')
      }
      this.$store.commit('onLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 780px;
  }
}
.innerContent {
  overflow: auto;
}
</style>
